import React from 'react';

function BottomNav({ route, setRoute }) {
  return (
    <div className="fixed bottom-2 left-0 right-0 flex justify-center">
      <div className="max-w-md w-full px-4">
        <div className="bg-white dark:bg-dark-surface rounded-xl shadow-lg p-2 flex justify-between">
          <button onClick={() => setRoute("home")} className={`flex-1 py-2 dark:text-dark-text ${route==='home'?'font-semibold':''}`}>Home</button>
          <button onClick={() => setRoute("log-earth")} className={`flex-1 py-2 dark:text-dark-text ${route.startsWith('log-')?'font-semibold':''}`}>Log</button>
          <button onClick={() => setRoute("insights")} className={`flex-1 py-2 dark:text-dark-text ${route==='insights'?'font-semibold':''}`}>Insights</button>
          <button onClick={() => setRoute("settings")} className={`flex-1 py-2 dark:text-dark-text ${route==='settings'?'font-semibold':''}`}>Settings</button>
        </div>
      </div>
    </div>
  );
}

export default BottomNav;
